module.exports = __webpack_public_path__ + "img/BD5345_460F11_732622_EDB7B1-256px.727b21a5.png";